// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PagesView__PagesView___3PFsu{align-self:flex-start;box-sizing:border-box;outline:none;-webkit-overflow-scrolling:touch;width:100%}.PagesView__PagesViewResize___crBAY{}.PagesView__PagesViewResize___crBAY .ReactVirtualized__Grid{overflow:hidden!important}.PagesView__HighlightPagesView___3H4Jk:focus:after{border:2px solid #2680eb;box-shadow:0 0 0 1px #2680eb;content:\" \";display:block;height:calc(100% - 4px);left:0;pointer-events:none;position:absolute;top:0;width:calc(100% - 4px)}.PagesView__animated___i4TG6{transform:translateX(0);transition:transform .2s ease}.PagesView__slideOut___3pLzf{transform:translateX(-100%)}.PagesView__slideIn___dY24T{transform:translateX(100%)}", ""]);
// Exports
exports.locals = {
	"PagesView": "PagesView__PagesView___3PFsu",
	"PagesViewResize": "PagesView__PagesViewResize___crBAY",
	"HighlightPagesView": "PagesView__HighlightPagesView___3H4Jk",
	"animated": "PagesView__animated___i4TG6",
	"slideOut": "PagesView__slideOut___3pLzf",
	"slideIn": "PagesView__slideIn___dY24T"
};
module.exports = exports;
